import {NgModule, Component, Input, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, ViewChild, Renderer2, QueryList, ViewChildren} from '@angular/core';

@Component({
    selector: 'copy',
    template:`
        <ng-container>
            <ng-container *ngIf="pre; else noPre">
                <pre #copy [ngClass]="{'clamp-lines': clampLines != nil }" [class.on]="toggle" [innerText]="item.copy"></pre>
            </ng-container>
            <ng-template #noPre>
                <div #copy [ngClass]="{'clamp-lines': clampLines != nil }" [class.on]="toggle" [innerHtml]="item.copy" >
                </div>
            <ng-template>            
        <ng-container>
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Copy {
    @Input() item: any;
    @Input() pre:boolean;
    @Input() clampLines:number;
    @Input() toggle:boolean = true;

    @ViewChildren('copy', { read: ElementRef }) containers:QueryList<ElementRef>

    constructor(private renderer:Renderer2) {
    }

    ngAfterViewInit() {
        if (this.containers) {
            this.containers.forEach((item, index, arr) => {
                this.renderer.setAttribute(item.nativeElement, "style", "--lines:" + this.clampLines)
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/copy-row/copy.component.ts